module.exports = __webpack_public_path__ + "media/images/icons/duotone-icons/Electric/Washer-7e39f088d041bc16f493290e72fd4952.svg";